// let apiUrl = "https://api.personointi.toyota.letm.com/api/public/";
let apiUrl = "/proxy/api/public/";
if (process.env.NODE_ENV === "development") {
  apiUrl = "https://api.personointi.toyota.letm.com/api/public/";
}
export default {
  apiUrl: apiUrl
};
